import { Clickable, Col, Divider, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 4px;
  width: 264px;
  height: 310px;

  position: absolute;
  right: -627px;
  top: 19px;

  ${(props) =>
    props.isMobile &&
    `
    top: 30px;
    right: 10px;
  `}

  background-color: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  z-index: 3;
`;

const CloseMenu = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

const SettingObject = ({ check, text, onClick }) => {
  return (
    <Col marg="4px 0 0" noFlex wid="100%">
      <Clickable marg="4px 0 0" onClick={onClick}>
        <Row ht="48px" between center wid="100%">
          <Row center>
            <Text med>{text}</Text>
          </Row>

          {check && (
            <Row noFlex centerAll>
              <Icon type="check" dimensions={20} col={theme.SECONDARY} />
            </Row>
          )}
        </Row>
      </Clickable>
    </Col>
  );
};

const Menu = ({ visible, setVisible, updateFilters, filters }) => {
  const { isMobile } = useSelector((state) => state.appState),
    { showOnlyFavorites, showHidden } = filters,
    { t } = useTranslation();

  return (
    <React.Fragment>
      <Clickable onClick={() => setVisible(false)}>
        <CloseMenu />
      </Clickable>

      <Col pos="absolute" right={isMobile ? '0' : 'unset'}>
        <Wrapper isMobile={isMobile}>
          <Text b2 col={theme.GREY_60} marg="8px 0 0">
            Favorites
          </Text>

          <SettingObject
            text={t('messages.favoritesAtTop')}
            onClick={() => updateFilters('showOnlyFavorites', false)}
            check={!showOnlyFavorites}
          />

          <SettingObject
            text={t('messages.favoritesOnly')}
            onClick={() => updateFilters('showOnlyFavorites', true)}
            check={showOnlyFavorites}
          />

          <Divider />

          <Text b2 col={theme.GREY_60} marg="16px 0 0">
            {t('messages.hiddenChats')}
          </Text>

          <SettingObject
            text={t('messages.excludeHidden')}
            onClick={() => updateFilters('showHidden', false)}
            check={!showHidden}
          />

          <SettingObject
            text={t('messages.showHidden')}
            onClick={() => updateFilters('showHidden', true)}
            check={showHidden}
          />
        </Wrapper>
      </Col>
    </React.Fragment>
  );
};

export default Menu;
